<template>
  <div>
    <v-tabs centered icons-and-text>
      <v-tab key="general" :to="baseAddress + 'edit/' + userId + '/basic'">
        {{ $t("settings.users.menu.personalData") }}
        <v-icon>account_box</v-icon>
      </v-tab>
      <v-tab
        key="delegations"
        :to="baseAddress + 'edit/' + userId + '/delegation'"
        v-if="this.$store.getters['companyContext'] != null && $store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2"
      >
        {{ $t("settings.users.menu.delegationPreferencesData") }}
        <v-icon>fa-suitcase</v-icon>
      </v-tab>
      <v-tab key="permissions" :to="baseAddress + 'edit/' + userId + '/roles-and-permissions'">
        {{ $t("settings.users.menu.rolesAndPermissions") }}
        <v-icon>pan_tool</v-icon>
      </v-tab>
      <v-tab
        key="costCentre"
        :to="baseAddress + 'edit/' + userId + '/cost-centre'"
        v-if="
          this.$store.getters['companyContext'] != null &&
            ($store.getters['userProperties'].system_settings.is_module_travel_service_enabled === 2 ||
              $store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2)
        "
      >
        {{ $t("settings.users.menu.costCentre") }}
        <v-icon>fa-vote-yea</v-icon>
      </v-tab>
      <v-tab
        key="additionalData"
        :to="baseAddress + 'edit/' + userId + '/additional-data'"
        v-if="this.$store.getters['companyContext'] != null && this.$store.state.Auth.isWnt === false"
      >
        {{ $t("settings.users.menu.additionalData") }}
        <v-icon>fa-cog</v-icon>
      </v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: "UserSettingsMenu",
  computed: {
    userId() {
      return this.$route.params.id;
    },
    baseAddress() {
      return this.$store.getters["companyContext"] == null ? "/admin/users/" : "/settings/users/";
    }
  }
};
</script>

<style scoped></style>
